import { render, staticRenderFns } from "./UiShowMenu.vue?vue&type=template&id=644652c9&lang=pug&"
import script from "./UiShowMenu.vue?vue&type=script&lang=js&"
export * from "./UiShowMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports